export const DROPDOWN_BUTTON = "si.components.countries_dd.button.text.single";
export const DROPDOWN_PLACEHOLDER = "si.components.countries_selection_modal.dd_placeholder";
export const LABEL_COUNTRY = "si.lead_gen_filters.internationalCountry.label";
